import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, ChevronRight } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';

const API = process.env.REACT_APP_BACKEND_URL;

/** Alert widget — only renders when one or more visas are due for cancellation. */
export const VisaCancellationCard = () => {
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API}/api/staff-vault/cancellation-due`)
      .then((r) => setRows(r.data?.rows || []))
      .catch(() => setRows([]));
  }, []);

  if (rows.length === 0) return null;

  return (
    <Card className="border-amber-300 bg-amber-50 cursor-pointer hover:shadow-md transition-shadow"
      onClick={() => navigate('/staff-vault')} data-testid="dash-visa-cancellation-card">
      <CardContent className="p-4 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="p-2 rounded-lg bg-amber-100"><AlertTriangle className="h-5 w-5 text-amber-700" /></div>
          <div>
            <p className="font-semibold text-amber-900">{rows.length} visa(s) due for cancellation</p>
            <p className="text-xs text-amber-700">
              {rows.slice(0, 3).map((r) => r.employee_name).join(', ')}
              {rows.length > 3 ? ` +${rows.length - 3} more` : ''} — 6-month freeze elapsed.
            </p>
          </div>
        </div>
        <div className="flex items-center gap-1 text-amber-700 text-sm font-medium">
          Staff Vault <ChevronRight className="h-4 w-4" />
        </div>
      </CardContent>
    </Card>
  );
};

export default VisaCancellationCard;
